<template>
  <div class="doc-download doc-td">
    <span class="download-text" @click="startDownLoad()" v-if="down_progress === 0">{{downText}}</span>
    <span class="open-directory-text" v-else-if="down_progress === 100" @click="openDownFile(doc)">打开文件夹</span>
    <div class="drawing-progress" v-else>
      <div class="progress-wrapper">
        <div class="progress-div" :style="{ width: `${down_progress}%` }"></div>
        <div class="progress-text">{{down_progress}}%</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { Message, Loading } from 'element-ui';
import { CheckLibs, UserService } from '@digital-supply-chain/module'
import { WinForm, ApiService } from '@/libs';
import { FileService } from '@/service';
import Event, {EventEnum} from '@/EventEmeitter'
import { getSavePath } from '../lectoParamsDown';

export default {
  props: {
    doc: {
      typeof: Object,
      default: {},
    },
    downText: { default: '下载' },
    isSave: { default: true },
  },
  inject: ['productDetail','downLoadCheck'],
  computed: {
    ...mapState({
      progressData:state => state.modeldown.progressData,
    }),
    // 下载进度
    down_progress() {
      const { FileName, FileType } = this.doc;
      const findOne = this.progressData[`${FileName}_${FileType}`] || {};
      return findOne.progress || 0;
    },
  },
  methods: {
    ...mapMutations('modeldown', ['setProgress']),

    openDownFile() {
      const { FileName, FileType } = this.doc;
      const findOne = this.progressData[`${FileName}_${FileType}`] || {};
      findOne && (WinForm.md.openDirectory(`/select,${findOne.url}`));
    },

    startDownLoad() {
      this.downLoadCheck(() => {
        this.downLoad();
      })
    },

    async downLoad() {
      if (!UserService.token()) {
        Event.emit(EventEnum.LOGIN_OPEN);
        return false;
      }

      const { FileType, ID, FileName, FileExt } = this.doc;
      let path = '';
      const key = FileName + '_' + FileType;
      // let check = await downloadCheckFun(this.productDetail.CompID, this.productDetail.ProdID);
      // if (!check) return;
      let downUrl = `${ApiService.JrzzApi}/file/265/download?dataId=${ID}&token=${encodeURIComponent(UserService.token())}`;
      console.log(downUrl);

      if (!this.isSave) {
        this.$emit('docDown', downUrl);
        return;
      }

      // 浏览器端下载
      if (!CheckLibs.isClient()) {
        // window.open(downUrl + `&fromOssSrc=true&fileName=${`${FileName}${FileExt}`}`)
        this.fullLoading = Loading.service({
            lock: true,
            text: '正在获取模型数据...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.5)'
        });
        FileService.getBlob(downUrl).then(blob => {
          this.fullLoading && this.fullLoading.close();
          if (blob) {
            FileService.saveAs(blob, `${FileName}${FileExt}`)
          }
        }).catch(() => {
          this.fullLoading && this.fullLoading.close();
          Message.error('获取模型数据出错');
        })
        return false;
      }

      // 客户端下载
      if(FileType == 8) {
        path = await getSavePath(FileName, FileExt.substr(1));
        if(!path) {
            return false;
        }
      } else {
        path =  await WinForm.md.saveFileDlg("所有文件(*.*)|*.*", "", FileName + FileExt);
      }
      if (path == "failed") return;
      //添加到下载任务
      this.setProgress({
          type: 'add',
          key,
          value: {
            sku_name: FileName,
            file_name: FileName,
            progress: 1,
            file_type: FileType,
            url: path,
          },
      });
      WinForm.md.download2(downUrl, path, key, this.DownLoadProgress);
    },

    DownLoadProgress(key, progress, speed, status, statusDesc, totalSize) {//下载回调
      console.log(key, progress, speed, status, statusDesc, totalSize);
      switch (status) {
        case "MD_DOWNLOAD"://下载中
          this.setProgress(
            {
              type: progress >= 100 ? 'del' : 'edit_gress',
              key,
              progress: progress <= 0 ? 1 : progress,
            }
          );
          break;
        case "MD_COMPLETE"://下载完成
          this.setProgress(
            {
              type: 'edit_gress',
              key,
              progress: 100,
            }
          );
          break;
        default:
          Message('下载异常');
          break;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.doc-download {
    text-align: center;
    cursor: pointer;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
.drawing-progress {
    width: 100%;
    align-items: center;
    height: 100%;
    display: flex;
}

.drawing-progress .progress-wrapper {
    margin-left: 8px;
    margin-right: 8px;
    height: 6px;
    flex: 1 1 0;
    background-color: #EBEEF5;
    border-radius: 5px;
    overflow: hidden;
}

.drawing-progress .progress-div {
    width: 0;
    height: 100%; 
    transition: width .15s;
    border-radius: inherit;
    background-color: #409EFF;
}

.drawing-progress .progress-text{
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
